import React, { useContext, useEffect, useState } from 'react'
import tipopagodata from '../data/tipopagodata.json'

export const TipopagoCmp = ({ addTipopago }) => {

  function handlerSeleccion(tipodepago) {
    addTipopago(tipodepago);
  }
  
  return (
    <div>
      <h1 className="text-2xl font-bold mb-7">Como desea realizar su pago?</h1>
      <div className="text-left">
        <p>Escoja la opción de pago, en el caso del cup es al cambio en el momento de realizar la sesion tasa de cambio de <p className='font-bold'>El toque</p></p>
        <p>En el caso del usd efectivo los billetes deben estar en buen estado sin marcas y sin roturas.</p>
      </div>
      <div className="flex flex-col items-center">
        {tipopagodata.map((item) => (
          <button style={{ backgroundColor: 'white', color: 'black'}} key={item.tipopago} className="btn m-5" name={item.tipopago} onClick={() => handlerSeleccion(item)}>
            {item.tipopago}
          </button>
        ))}
      </div>
    </div>
  )
}